import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import TYPES, { FLEX } from '@v4/constants/quiz'
import WhiteThemeProvider from '@v4/components/sections/Question/Components/WhiteThemeProvider'
import OptionList from './components/OptionList'
import SubmitButton from '../../components/SubmitButton'
import { useMultipleChoice } from './MultipleChoice.hooks'

const MultipleChoice = props => {
	const [
		{
			type,
			multiple,
			classes,
			justify,
			options,
			selectedOptions,
			pending,
			useOldCheckboxes,
			shadow,
			editable,
			isDragging,
		},
		{ handleSubmit, handleCheckboxClick, handleLabelEdit, handleAdd, handleSortStart, handleSortEnd, handleDelete },
	] = useMultipleChoice(props)

	return (
		<Box className={clsx(type, classes.root, 'q-radio')} color="common.optionColor" justifyContent={justify}>
			<WhiteThemeProvider>
				<OptionList
					className={isDragging ? classes.dragging : undefined}
					items={options}
					pending={pending}
					selectedOptions={selectedOptions}
					withEdition={editable}
					onClick={handleCheckboxClick}
					onAdd={handleAdd}
					onDelete={handleDelete}
					useDragHandle
					draggable={editable}
					axis="y"
					lockAxis="y"
					onSortStart={handleSortStart}
					onSortEnd={handleSortEnd}
					helperClass={clsx(classes.sortableHelper, 'sortable-helper')}
					shadow={shadow}
					useOldCheckboxes={useOldCheckboxes}
					onLabelEdit={handleLabelEdit}
					type={multiple ? 'checkbox' : 'radio'}
				/>
			</WhiteThemeProvider>
			<Box className="q-radio-button-container" mt={3.75} display="flex" justifyContent={justify}>
				<SubmitButton loading={pending} className="q-checkbox-button" onClick={handleSubmit} />
			</Box>
		</Box>
	)
}

MultipleChoice.propTypes = {
	type: PropTypes.oneOf([TYPES.CHECKBOX, TYPES.MULTI_RADIO]),
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onClick: PropTypes.func,
	justify: PropTypes.oneOf(Object.values(FLEX)),
	pending: PropTypes.bool,
	answers: PropTypes.array,
	shadow: PropTypes.bool,
	useOldCheckboxes: PropTypes.bool,
}

MultipleChoice.defaultProps = {
	pending: false,
	justify: FLEX.START,
	onClick: () => {},
}

export default memo(MultipleChoice)
